export IconToggle from './IconToggle'

export default from './IconToggle'



// WEBPACK FOOTER //
// ./src/IconToggle/index.js